import { render, staticRenderFns } from "./DataPreview.vue?vue&type=template&id=165c9c6d&scoped=true&"
import script from "./DataPreview.vue?vue&type=script&lang=js&"
export * from "./DataPreview.vue?vue&type=script&lang=js&"
import style0 from "./DataPreview.vue?vue&type=style&index=0&id=165c9c6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c9c6d",
  null
  
)

export default component.exports